import React from 'react';
import { Box, Typography } from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { useTranslate } from 'react-admin';
import NoteItemCollapse from './NoteItemCollapse';

interface ExternalIdentification {
    email?: string;
    name?: string;
    [key: string]: any;
}

interface Props {
    externalIdentification: ExternalIdentification;
}

// Adaptation of platform-v2 ShowNoteExternalIdentification to Material-UI v4
const ShowNoteExternalIdentification: React.FC<Props> = ({ externalIdentification }) => {
    const t = useTranslate();
    if (!externalIdentification) return null;

    const { email, name } = externalIdentification || {};

    return (
        <NoteItemCollapse title={t('app.rikutec.externalIdentification.label')} icon={<AccountCircleIcon />}>
            <Box style={{ display: 'grid', gap: 8, padding: 8, paddingLeft: 16, paddingRight: 16 }}>
                {name && (
                    <Typography variant='body2'>
                        <b>{t('app.rikutec.externalIdentification.name')}:</b> {name}
                    </Typography>
                )}
                {email && (
                    <Typography variant='body2'>
                        <b>{t('app.rikutec.externalIdentification.email')}:</b> {email}
                    </Typography>
                )}
            </Box>
        </NoteItemCollapse>
    );
};

export default ShowNoteExternalIdentification;
